import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

import SharedAsset from '../SharedAsset';

const Bubble = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center',
  justifyContent: 'flex-start',
  borderRadius: 4,
  padding: 16,
  backgroundColor: theme.palette.error.main
}));

const AlertIcon = styled(SharedAsset)(() => ({
  marginRight: 16,
  width: 64,
  height: 64
}));

const ContentWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center',
  justifyContent: 'flex-start',
  margin: 'auto 0'
}));

const ArtBubble = ({ text, className }) => {
  const textArray = Array.isArray(text) ? text : [text];
  const copy = textArray.filter((item) => (typeof item === 'string' && item.length));

  if (!copy.length) {
    return null;
  }

  return (
    <Bubble role="alert" className={className}>
      <AlertIcon
        src="/icon/misc/art-bubble-64.svg"
        width={64}
        alt=""
      />
      <ContentWrapper>
        {copy
          .filter((item) => (typeof item === 'string' && item.length))
          .map((val) => (
            <Text
              data-testid="artbubble-text"
              key={val}
              tag="p"
              size="sm"
              color="focus00"
              bold
              gutterBottom
            >
              {val}
            </Text>
          ))}
      </ContentWrapper>
    </Bubble>
  );
};

ArtBubble.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  className: PropTypes.string
};

ArtBubble.defaultProps = {
  className: null
};

export default ArtBubble;
